// Choix du produit : "GLOBALONG" ou "VITA"
const PRODUCT = "GLOBALONG";

let CONST_URL, CONST_URL_CRM, CONST_URL_MEMBRE;

if (PRODUCT === "GLOBALONG") {
    CONST_URL = 'https://www.globalong.com';
    CONST_URL_CRM = 'https://crm.globalong.com';
    CONST_URL_MEMBRE = 'https://membre.globalong.com';
} else if (PRODUCT === "GLOB_DK") {
    CONST_URL = 'https://www.vita-explorers.dk';
    CONST_URL_CRM = 'https://crm.vita-explorers.dk';
    CONST_URL_MEMBRE = 'https://membre.vita-explorers.dk';
} else if (PRODUCT === "TEST") {
    CONST_URL = 'https://testsite.globalong.com';
    CONST_URL_CRM = 'https://testcrm.globalong.com';
    CONST_URL_MEMBRE = 'https://testmembre.globalong.com';
} else if (PRODUCT === "DEV") {
    CONST_URL = 'https://www.globalongdev.com';
    CONST_URL_CRM = 'https://crm.globalongdev.com';
    CONST_URL_MEMBRE = 'https://membre.globalongdev.com';
}


export const API_URI = CONST_URL;
export const URL = CONST_URL;
export const URL_CRM = CONST_URL_CRM;

export const TOKENADMIN = localStorage.getItem('tokenAdmin');
